import { FADEIN, PARALLAX } from '../app.config';
import gsap from '@gsap/business';
import { ScrollTrigger } from '@gsap/business/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class Reveal {

  constructor(context) {
    this.context = context;
    this.init();
  }

  initAnimations() {
    this.items.forEach(el => {
      switch (el.type) {
        case 'parallax':
          PARALLAX && this.parallaxAnimation(el.items)
          break;
        case 'fadeIn':
          FADEIN && this.fadeInAnimation(el.items)
          !FADEIN && document.body.classList.add('fadein-off');
          break;
      }
    })
  }

  parallaxAnimation(items) {
    items.forEach((p, j) => {
      const speed = p.getAttribute('data-speed');
      gsap.fromTo(
        p,
        {
          y: -p.offsetHeight / 10 * speed,
        },
        {
          scrollTrigger: {
            trigger: p.parentElement,
            scrub: true,
            start: 'top bottom',
            invalidateOnRefresh: true,
            end: 'bottom top',
          },
          ease: 'none',
          y: p.offsetHeight / 10 * speed,
        }
      );
    });
  }

  fadeInAnimation(items) {
    ScrollTrigger.batch(items, {
      interval: 0.1,
      onEnter: (batch) => {
        gsap.to(batch, {
          duration: 0.3,
          autoAlpha: 1,
          stagger: 0.02,
          y: 0,
          ease: 'none',
          // scrollTrigger: {
          //   trigger: batch,
          //   start: 'top 80%',
          //   end: 'top 60%',
          //   scrub: true
          // },
        });
      },
    });
  }

  init() {
    this.items = [{
      type: 'parallax',
      items: Array.from(this.context.querySelectorAll('[data-speed]'))
    },
    {
      type: 'fadeIn',
      items: Array.from(this.context.querySelectorAll('._fade'))
    }]
    this.initAnimations();
  }
}
